import { IStore } from 'store/types';

export const selectEmployee = () => (state: IStore) => state.employee;
